import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { milwaukeeConfig } from "./data";

export default function MilwaukeeWIPage() {
  return <CityPageTemplate config={milwaukeeConfig} />;
}